import React, { useState } from "react";
import PropTypes from "prop-types";
import ReactPlayerLoader from '@brightcove/react-player-loader';
import AdvancedDownload from './advanced_download';

function AdvancedEditorModal(props) {
  const [player, setPlayer] = useState(undefined);

  const onSuccess = (e) => {
    setPlayer(e.ref);
  };

  return (
    <div className="advanced-editor-modal">
      <ReactPlayerLoader
        attrs={{ id: 'brightcove-advanced-video-editor-modal' }}
        accountId={props.video.accountID}
        videoId={props.video.videoID}
        playerId="default"
        onSuccess={(e) => onSuccess(e)}
      />
      { player ? <AdvancedDownload {...props} editor player={player} /> : null }
    </div>
  );
}

AdvancedEditorModal.propTypes = {
  attachment: PropTypes.shape({
    key: PropTypes.string,
    extension: PropTypes.string,
    height: PropTypes.number,
    filename: PropTypes.string
  }).isRequired,
  assetKey: PropTypes.string.isRequired,
  video: PropTypes.shape({
    accountID: PropTypes.string,
    videoID: PropTypes.string
  }).isRequired
};

export default AdvancedEditorModal;
